import React from 'react';
import styled from 'styled-components';
import {colours} from '../Styles';

function FooterItem(props) {
    const {light} = colours;
    const FooterItem = styled.div`
    min-width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px;
    .title {
        font-family: play, sans-serif;
        color: ${light};
        font-size: 20px;
        margin-bottom: 5px;
    }
    .children {
        font-size: 14px;
        font-family: sans-serif;
    }
    @media only screen and (max-width: 600px) {
       align-items: flex-start;
    }
    `;
    return (
        <FooterItem>
            <div className="title">{props.title}</div>
            <div className="children">{props.children}</div>
        </FooterItem>
    )
}

export default FooterItem;